import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import withRouter from 'react-router/withRouter';
import NotFound from '../../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import Slug from '../../../../components/slug/slug';
import IBDCategory from '../../../../components/ibd_category/ibd_category';
import matchMediaDesktop from '../../../../../utils/client_util';
import FranchiseIntro from '../../../../components/franchise_intro/franchise_intro';
import scrollToEl from '../../../../../utils/scroll_to_el_util';
import loadData from './gift_guide_page_state_manager';
import AdContainer from '../../../../components/ad/AdContainer';

class GiftGuide extends Component {
  static loadData(store) {
    return loadData(store);
  }
  componentDidMount() {
    this.isDesktop = matchMediaDesktop('64em');
  }

  componentDidUpdate() {
    scrollToEl('.ibd-category--active', 150);
  }

  render() {
    if (this.props.giftGuidePage.error || this.props.status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }
    if (this.props.giftGuidePage.isLoading) {
      return (
        <section className="innovation-by-design-page">
          <article className="innovation-by-design-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const { giftGuide, giftGuideDetail } = this.props;
    const year = get(this.props.match, 'params.year');
    const category = get(this.props.match, 'params.category');
    const sectionTitle = 'Browse By Categories';
    const slugParam = get(this.props, 'match.params.slug', '');

    // TODO: this needs to be updated.
    const encodedText = encodeURIComponent(
      "Browse Fast Company's 2018 holiday gift guide, a meticulously curated list of the latest, most innovative, most thoughtful design objects available in 13 categories."
    );
    const uri = `https://www.fastcompany.com/gift-guide/${slugParam}`;
    const specialText =
      "Browse @fastcompany's 2018 holiday gift guide, a meticulously curated list of the most thoughtful design objects.";

    return (
      <section className="innovation-by-design-page gift-guide-page">
        <AdContainer type="outstream" />
        <AdContainer type="break" />
        <FranchiseIntro
          poster={get(giftGuideDetail, 'logo_url')}
          title={get(giftGuideDetail, 'title')}
          desc={get(giftGuideDetail, 'intro')}
          social={{
            enableSticky: false,
            modifier: 'feature-feed',
            text: '',
            socialText: {
              twitter: specialText,
              linkedin: encodedText,
              email: encodedText
            },
            uri
          }}
          giftGuide={true}
        />

        <section className="ibd-list">
          <Slug slugName={sectionTitle} className="ibd-list" />
        </section>

        <section className="innovation-by-design-page__category-container">
          {giftGuide.map((cat, idx) => (
            <IBDCategory
              category={cat}
              key={get(cat, 'category_name')}
              index={String(idx)}
              year={year}
              active={category === get(cat, 'url')}
              slug="gift-guide"
              slugParam={slugParam}
            />
          ))}
        </section>
        <div className="ad-container">
          <AdContainer type="break" />
        </div>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  const ggData = get(state, 'giftGuide.data.rows');
  const ggDetail = get(state, 'giftGuideDetail.data.rows[0]');

  return {
    config: state.config || {},
    status: state.status.code,
    giftGuidePage: get(state, 'giftGuidePage') || {
      error: true
    },
    giftGuide: ggData || [],
    giftGuideDetail: ggDetail || ''
  };
}

GiftGuide.defaultProps = {
  status: 200
};

GiftGuide.propTypes = {
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  match: PropTypes.shape({}).isRequired,
  giftGuidePage: PropTypes.shape({
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  giftGuide: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  giftGuideDetail: PropTypes.shape({}).isRequired
};

export default withRouter(connect(mapStateToProps)(GiftGuide));
